/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impl_Bootstrap_WarningInputs */

const en_impl_bootstrap_warning = /** @type {(inputs: Impl_Bootstrap_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The prompt contains a one-time bootstrap token. Paste it only into an agent you trust.`)
};

const id_impl_bootstrap_warning = /** @type {(inputs: Impl_Bootstrap_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt memuat token bootstrap sekali pakai. Tempel hanya ke agent yang kamu percaya.`)
};

/**
* | output |
* | --- |
* | "The prompt contains a one-time bootstrap token. Paste it only into an agent you trust." |
*
* @param {Impl_Bootstrap_WarningInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const impl_bootstrap_warning = /** @type {((inputs?: Impl_Bootstrap_WarningInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impl_Bootstrap_WarningInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_impl_bootstrap_warning(inputs)
	return en_impl_bootstrap_warning(inputs)
});